// Where a cloud provider call goes (shared AI credits).
//
// Normally a call goes to /proxy/<provider>/… carrying the user's own key.
// On a mate's shared credits (`settings.creditShare`) it goes to the API
// instead, carrying the user's sign-in token and no key at all: the server
// checks the share, adds the owner's key and records the cost. The borrower's
// browser never holds the owner's key, which is what makes the cap, expiry
// and revoke real.

import { apiUrl, getToken } from "../../services/api";

export const isSharedCredits = (settings) => Boolean(settings?.creditShare?.id);

const sharedBase = (settings) => apiUrl(`/credit-shares/${settings.creditShare.id}/proxy`);

/**
 * @param {object} settings  llm settings for this call
 * @param {string} path      provider path, e.g. "/openai/chat/completions"
 * @param {object} headers   the headers for a direct call, key included
 * @returns {{ url: string, headers: object }}
 */
export const cloudRequest = (settings, path, headers) => {
  if (!isSharedCredits(settings)) return { url: `/proxy${path}`, headers };
  const { Authorization, "x-api-key": _key, ...rest } = headers;
  return {
    url: `${sharedBase(settings)}${path}`,
    headers: { ...rest, Authorization: `Bearer ${getToken() || ""}` },
  };
};

/**
 * The Gemini SDK builds its own URLs, so it's pointed at the shared route with
 * `httpOptions`. It insists on an API key, so it gets a placeholder; the
 * server ignores whatever key header arrives and uses the owner's.
 */
export const geminiRoute = (settings, apiKey) => {
  if (!isSharedCredits(settings)) return { apiKey };
  const origin = typeof window !== "undefined" ? window.location.origin : "http://localhost";
  return {
    apiKey: "shared-credits",
    httpOptions: {
      baseUrl: new URL(`${sharedBase(settings)}/google`, origin).toString(),
      headers: { Authorization: `Bearer ${getToken() || ""}` },
    },
  };
};
